export const getCompanyMetaResponseMock = {
  data: {
    id: 1,
    user_updated: "43aaae41-d690-49a8-840c-e78efd125f69",
    date_updated: "2025-01-30T12:32:24.900Z",
    translations: [
      {
        id: 1,
        company_meta_id: 1,
        instagram_url: "https://www.instagram.com/upacjentapl",
        linkedin_url: "https://pl.linkedin.com/company/upacjenta",
        facebook_url: "https://www.facebook.com/upacjenta",
        newsletter_terms_link: "https://upacjenta.pl/download/newsletter-terms-and-conditions",
        minHomeVisitPrice: 5900,
        languages_code: "pl-PL",
        contact_items: [
          {
            name: "Dział Pomocy",
            email: "support@upacjenta-pl.freshdesk.com",
          },
          {
            name: "Dział Sprzedaży i Partnerstw",
            email: "partnerstwa@upacjenta.pl",
          },
          {
            name: "Dział Marketingu i PR",
            email: "marketing@upacjenta.pl",
          },
          {
            name: "Dział HR i Rekrutacje",
            email: "rekrutacja@upacjenta.pl",
          },
        ],
        packages_tests_table_annotation:
          "* indywidualna cena badań przedstawiona na przykładzie cen z woj. mazowieckiego",
        raf_discount_amount: 10000,
        consultation_poll_link: "https://snbitt5wp4w.typeform.com/to/BQcASjPi",
        raf_min_basket_amount: 15000,
      },
    ],
  },
};
